import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CmfInterface } from '../interface/cmf-interface';
import { environment } from 'src/environments/enviroments';

@Injectable({
  providedIn: 'root'
})
export class CmfServiceService {

  constructor(private http: HttpClient) { }

  /*
    * Metodos para realizar consulta API CMF
  */

  //Crea un registro CMF
  newCmf(request: CmfInterface): Observable<any> { 
    const endpoint = `${environment.apiUrl}/Cmf/${request.companyId}/RegistroCmf`;
    return this.http.post<CmfInterface[]>(endpoint, request);
  }

  //Obtiene un registro CMF
  getCmf(request: Number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Cmf/${request}/obtenerCmf`;
    return this.http.get<CmfInterface[]>(endpoint);
  }

  //Modifica un registro CMF
  setCmf(request: CmfInterface): Observable<any> {
    const endpoint = `${environment.apiUrl}/?/${request}/?`;
    return this.http.put<CmfInterface[]>(endpoint, request);
  }

  updateSbif(request: string, isPartner = false): Observable<any> {
    let endpoint = `${environment.apiUrl}/Cmf/${request}/Update`;
    if(isPartner)
      endpoint = `${environment.apiUrl}/Cmf/${request}/UpdateAsPartner`;
    return this.http.post<boolean>(endpoint, null);
  }
  
}
